import React from 'react';
import { Home } from 'lucide-react';
import { SystemPlanningConfig, HomeSize, HOME_SIZE_LABELS, HOME_BASE_LOADS } from '../../types/systemPlanning';

interface Props {
  config: SystemPlanningConfig;
  updateConfig: (partial: Partial<SystemPlanningConfig>) => void;
}

const HOME_SIZES: HomeSize[] = ['small', 'medium', 'large', 'custom'];

export function HomeConfigSection({ config, updateConfig }: Props) {
  const displayKw =
    config.homeSize === 'custom'
      ? config.customHomeLoadKw
      : HOME_BASE_LOADS[config.homeSize];

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <label className="flex items-center gap-2 font-medium text-gray-700">
          <Home size={16} className="text-purple-600" />
          Home Load
        </label>
        <span className="text-sm font-semibold text-purple-700 bg-purple-50 px-2 py-0.5 rounded">
          {displayKw.toFixed(1)} kW
        </span>
      </div>

      <div className="flex gap-1 mb-3">
        {HOME_SIZES.map(size => (
          <button
            key={size}
            onClick={() => updateConfig({ homeSize: size })}
            className={`flex-1 text-xs py-1.5 rounded font-medium transition-colors ${
              config.homeSize === size
                ? 'bg-purple-600 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {size === 'custom' ? 'Custom' : size.charAt(0).toUpperCase() + size.slice(1)}
          </button>
        ))}
      </div>

      {config.homeSize === 'custom' && (
        <div className="flex items-center gap-2">
          <input
            type="number"
            min={0.1}
            max={20}
            step={0.1}
            value={config.customHomeLoadKw}
            onChange={e => updateConfig({ customHomeLoadKw: Math.max(0.1, Math.min(20, Number(e.target.value))) })}
            className="flex-1 text-sm border border-gray-200 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-purple-500"
          />
          <span className="text-sm text-gray-500">kW</span>
        </div>
      )}
    </div>
  );
}
